import { Controller } from "@hotwired/stimulus"

// Starts a note on a specific message, and scrolls back to that message from the
// quote chip on a posted note. Lives on the thread so both the message cards and
// the composer are in reach — the composer is a sibling of the scroller, not a
// parent of the cards.
export default class extends Controller {
  start(event) {
    const composer = this.composer()
    if (!composer) return

    composer.anchorTo({
      messageId: String(event.params.messageId || ""),
      excerpt: event.params.excerpt || ""
    })
  }

  reveal(event) {
    event.preventDefault()
    const messageId = event.params.messageId
    if (!messageId) return

    const card = this.element.querySelector(`#message_${messageId}`)
    if (!card) return

    // A collapsed middle message is a one-line row with none of the text the note quotes, so it is
    // opened first and the scroll lands on the card it becomes.
    const collapse = this.application.getControllerForElementAndIdentifier(this.element, "message-collapse")
    if (collapse && card.classList.contains("message-card--collapsed")) {
      collapse.expand(card).then((expanded) => this.highlight(expanded))
      return
    }

    this.highlight(card)
  }

  highlight(card) {
    if (!card) return

    card.scrollIntoView({ block: "center", behavior: "smooth" })
    card.classList.add("is-anchor-target")
    window.setTimeout(() => card.classList.remove("is-anchor-target"), 1600)
  }

  composer() {
    const root = this.element.querySelector("#comment_composer")
    const form = root?.querySelector("[data-controller~='composer']") || root?.querySelector("form")
    if (!form) return null

    return this.application.getControllerForElementAndIdentifier(form, "composer")
  }
}
